<mat-toolbar class="header">
	<button mat-icon-button (click)="onToggleSidebar()" class="menu-button">
		<mat-icon>menu</mat-icon>
	</button>

	<div class="logo-container">
		<img src="logo.png" alt="Zanga African Metrics" class="logo" />
	</div>

	<span class="spacer"></span>

	<nav class="nav-items">
		<a
			*ngIf="hasGlobalAccess"
			mat-button
			routerLink="/home"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: true }"
			(click)="navigateTo('/home'); $event.preventDefault()"
		>
			<mat-icon>home</mat-icon>
			Home
		</a>
		<a
			mat-button
			routerLink="/global-management"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			*ngIf="hasGlobalAccess"
			(click)="navigateTo('/global-management'); $event.preventDefault()"
		>
			<mat-icon>settings</mat-icon>
			Global Management
		</a>
		<a
			mat-button
			routerLink="/partners"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			*ngIf="hasPartnerAdminAccess || hasGlobalAccess"
			(click)="navigateTo('/partners'); $event.preventDefault()"
		>
			<mat-icon>business</mat-icon>
			Partners
		</a>
		<a
			mat-button
			routerLink="/organizations"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			*ngIf="hasOrganizationAccess || hasGlobalAccess"
			(click)="navigateTo('/organizations'); $event.preventDefault()"
		>
			<mat-icon>groups</mat-icon>
			Organizations
		</a>
		<a
			mat-button
			routerLink="/questionnaires"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			*ngIf="hasAssessmentAccess"
			(click)="navigateTo('/questionnaires'); $event.preventDefault()"
		>
			<mat-icon>quiz</mat-icon>
			Questionnaires
		</a>
		<a
			mat-button
			routerLink="/icons"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			*ngIf="hasIconsAccess"
			(click)="navigateTo('/icons'); $event.preventDefault()"
		>
			<mat-icon>emoji_symbols</mat-icon>
			Icons
		</a>
	</nav>

	<button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu">
		<div class="user-avatar">
			<img
				*ngIf="(user$ | async)?.photo_url"
				[src]="(user$ | async)?.photo_url"
				alt="Profile photo"
			/>
			<mat-icon *ngIf="!(user$ | async)?.photo_url">account_circle</mat-icon>
		</div>
	</button>

	<mat-menu #userMenu="matMenu" class="user-menu-panel">
		<div class="user-info" *ngIf="user$ | async as user">
			<p class="email">{{ user.email }}</p>
		</div>
		<a mat-menu-item routerLink="/profile" (click)="navigateTo('/profile'); $event.preventDefault()">
			<mat-icon>person</mat-icon>
			<span>Profile</span>
		</a>
		<mat-divider></mat-divider>
		<button mat-menu-item (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>Logout</span>
		</button>
	</mat-menu>
</mat-toolbar>
